import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import DialogHeader from "app/components/common/DialogHeader";

const StatusChangeDialog = ({
  open,
  handleClose,
  handleStatusChange,
  loading,
  route = null,
}) => {
  const newStatus = route?.partiallyDeleted ? "Active" : "Inactive";

  const handleSubmit = () => {
    handleStatusChange();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { minWidth: "25vw" },
      }}
    >
      <DialogHeader title="Change Route Status" handleClose={handleClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography variant="h6">
            Are you sure you want to change the status to{" "}
            <strong>{newStatus}</strong>?
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction={"row"} justifyContent={"center"} gap={2}>
          <LoadingButton
            color="secondary"
            variant="outlined"
            size="medium"
            onClick={handleClose}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            color="primary"
            loading={loading}
            variant="contained"
            size="medium"
            onClick={handleSubmit}
          >
            {newStatus === "Active" ? "Activate" : "Deactivate"}
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeDialog;
